var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMoney = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "108.56 228.6 862.9 622.81"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 62.59,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M139.86 339.92c0-44.2 35.83-80.03 80.03-80.03h640.24c44.2 0 80.03 35.83 80.03 80.03v400.16c0 44.2-35.83 80.03-80.03 80.03H219.88c-44.2 0-80.03-35.83-80.03-80.03V339.92Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 524.77,
  cy: 537.84,
  r: 128.32
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M139.86 419.95c88.39 0 160.05-71.66 160.05-160.05M780.09 820.11c0-88.39 71.66-160.05 160.05-160.05"
})));
export default SvgMoney;